import { useEffect, useState } from 'react'
import { isFramed } from '@/utils/embeddedContext'

/**
 * Clickjacking defense for the OAuth consent surface.
 *
 * The authoritative protection is an HTTP response header the HOST/CDN must send for the
 * `/oauth/authorize` route:
 *
 *     Content-Security-Policy: frame-ancestors 'none'
 *     X-Frame-Options: DENY
 *
 * This SPA is served as static assets, so there is no per-route server header mechanism in
 * this repo (no `public/_headers`, amplify custom-headers, or edge rule was found). Until the
 * host is configured to emit the headers above for this route, this hook is a defense-in-depth
 * fallback: it detects when the page is rendered inside a frame and lets the page refuse to
 * render the consent UI (a framed identity-confirmation screen is the exact attack the header
 * prevents). This runtime check is NOT a substitute for the header — configure the host too.
 */
export function useIsFramed(): boolean {
  const [framed, setFramed] = useState<boolean>(false)

  useEffect(() => {
    setFramed(isFramed())
  }, [])

  return framed
}
